import React from "react";

import { makeStyles } from "@material-ui/styles";

import { Drawer, Typography, Divider } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

import { translate } from "jazasoft";

import { isEmpty } from "../../../utils/helpers";

import LibraryActivityDetails from "./LibraryDetails";
import OrderDetails from "./OrderDetails";
import InvoiceDetails from "./InvoiceDetails";
import GRNDetails from "./GRNDetails";
// import FabAssociationDetails from "./FabAssociationDetails";
// import ErrorDetails from "./ErrorDetails";
import ExternalRollDetails from "./ExternalRollDetails";
import RollInfoDetails from "./RollInfoDetails";
import FpoDetails from "./FpoDetails";
import GenericActivityDetails from "./GenericActivityDetails";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flex: 1,
    flexDirection: "column"
  },
  drawerPaper: {
    maxWidth: 1000,
    minWidth: 800
  },
  drawerHeader: {
    display: "flex",
    width: props => props.drawerWidth || 500,
    alignItems: "center",
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-start"
  },
  content: {
    flex: 1
  }
}));

const libraryEntityList = [
  "AlertReason",
  "Customer",
  "Department",
  "FabricCategory",
  "FabricPattern",
  "Product",
  "Supplier",
  "Season",
  "Size",
  "Table",
  "Unit",
  "Warehouse"
];

const ActivityDetailsDrawer = ({ open, userActivity, onDrawerClose, translate }) => {
  const classes = useStyles({ drawerWidth: ["Order"].includes(userActivity?.entityName) ? 1080 : 500 });

  const isFailed = userActivity?.status === "Failure";

  const isLibraryEntity = libraryEntityList.includes(userActivity?.entityName);
  const isOrderEntity = userActivity?.entityName === "Order";
  const isInvoiceEntity = userActivity?.entityName === "Invoice";
  const isGRNEntity =
    userActivity?.entityName === "SupplierRoll" && (userActivity?.event === "GRN Completed" || userActivity?.event === "GRN Deleted");
  // const isFabAssociationEntity = userActivity?.entityName === "Ledger";
  const isExternalRollEntity = userActivity?.entityName === "Invoice QC";
  const isRollInfoEntity = userActivity?.entityName === "RollInfo";
  const isFpoEntity = userActivity?.entityName === "FactoryProductionOrder";

  return (
    <Drawer classes={{ paper: classes.drawerPaper }} anchor="right" open={open} onClose={onDrawerClose} style={{ flex: 1 }}>
      <div className={classes.root}>
        {/** Drawer Header */}
        <div className={classes.drawerHeader}>
          <div style={{ padding: "0.5rem" }}>
            <IconButton onClick={onDrawerClose}>
              <ChevronRightIcon />
            </IconButton>
          </div>

          <div style={{ paddingHorizontal: 10, width: "100%" }}>
            <Typography style={{ fontWeight: "bold", fontSize: 16 }}>
              {`Actvity Details${!isEmpty(userActivity?.searchText) ? `: ${userActivity.searchText}` : ""}`}
            </Typography>
          </div>
        </div>
        <Divider />

        {/** Drawer Content **/}

        <div className={classes.content}>
          {/* Component for library activities */}
          {isLibraryEntity && !isFailed && <LibraryActivityDetails userActivity={userActivity} />}

          {/* Component for order activities */}
          {isOrderEntity && !isFailed && <OrderDetails userActivity={userActivity} />}

          {/* Component for invoice activities */}
          {isInvoiceEntity && !isFailed && <InvoiceDetails userActivity={userActivity} />}

          {/* Component for GRN activities */}
          {isGRNEntity && !isFailed && <GRNDetails userActivity={userActivity} />}

          {/* Component for Fabric Association activities */}
          {/* {isFabAssociationEntity && !isFailed && <FabAssociationDetails userActivity={userActivity} />} */}

          {/* Component for External Roll activites */}
          {isExternalRollEntity && !isFailed && <ExternalRollDetails userActivity={userActivity} />}

          {/* Component for Roll Info activites */}
          {isRollInfoEntity && !isFailed && <RollInfoDetails userActivity={userActivity} />}

          {/* Component for FPO activites */}
          {isFpoEntity && !isFailed && <FpoDetails userActivity={userActivity} translate={translate} />}

          {/* Generic Activity*/}
          {/* {(isEmpty(userActivity?.event) || isFailed || isFabAssociationEntity) && <GenericActivityDetails userActivity={userActivity} />} */}

          <GenericActivityDetails userActivity={userActivity} />
        </div>
      </div>
    </Drawer>
  );
};

export default translate(ActivityDetailsDrawer);
